import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import Select from 'react-select';
import ENUMS from '../../enums';
import { domManipulator, formatter, enumHelper } from '../../utils';
import * as discountCodesActions from '../../redux/discountCodes/actions';
import * as cafeActions from '../../redux/cafes/actions';
import Spin from '../../components/loading';
import AutoComplete from '../../components/autoComplete';
import './styles.scss';
import DatePicker from './../../components/FormElements/DatePicker/DatePicker';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';
import jmoment from 'moment-jalaali';

class AddOrEditDiscountCode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedUsersInfo: [],
      isSearched: false,
      minOrderInReservationValue: '',
      minSuccessfulReservationValue: '',
      allowedToUse: '',
      specialUsers: [],
      specialUserIds: [],
      searchText: '',

      loaded: false,

      errors: {},

      isWithPercentage: true,
      title: '',
      code: '',
      discountCodeQuantity: '',
      minOrderAmount: '',
      validFrom: '',
      validTo: '',
      cafeId: null,

      codeInputInvalidMessage: '',
      codeInputValidateStatus: '',

      titleInputInvalidMessage: '',
      titleInputValidateStatus: '',

      discountCodeQuantityInputInvalidMessage: '',
      discountCodeQuantityInputValidateStatus: '',

      validFromInputInvalidMessage: '',
      validFromInputValidateStatus: '',

      validToInputInvalidMessage: '',
      validToInputValidateStatus: '',

      minOrderInReservationValueInputValidateStatus: '',
      minOrderInReservationValueInputInvalidMessage: '',

      minSuccessfulReservationValueInputValidateStatus: '',
      minSuccessfulReservationValueInputInvalidMessage: '',

      permittedUsersInputValidateStatus: '',
      permittedUsersInputInvalidMessage: '',

      minOrderAmountInputValidateStatus: '',
      minOrderAmountInputInvalidMessage: '',

      specialUserIdsInputValidateStatus: '',
      specialUserIdsInputInvalidMessage: '',
    };
  }

  componentDidMount() {
    this.props.getAllCafeNamesForPanel();

    if (this.props.location.editMode) {
      this.props.fetchDiscountCodeById(this.props.location.discountCodeId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.location.editMode &&
      prevState.loaded == false &&
      Object.entries(this.props.discountCodeDetails).length > 0
    ) {
      let {
        title,
        amount,
        minOrderAmount,
        specialUsers,
        code,
        type,
        specialUserIds,
        minOrderInReservationValue,
        minSuccessfulReservationValue,
        allowedToUse,
        validFrom,
        validTo,
        cafeId,
      } = this.props.discountCodeDetails;

      this.setState({
        title,
        specialUserIds,
        minOrderAmount,
        specialUsers,
        minOrderInReservationValue,
        minSuccessfulReservationValue,
        allowedToUse,
        discountCodeQuantity: amount,
        validFrom,
        validTo,
        isWithPercentage: type == ENUMS.DISCOUNT_CODES_TYPES.values.PERCENT ? true : false,
        code,
        loaded: true,
        cafeId,
      });
    }
  }

  handleDiscountCodeQuantityChange = event => {
    this.setState({
      discountCodeQuantity: event.target.value,
      discountCodeQuantityInputValidateStatus: '',
      discountCodeQuantityInputInvalidMessage: ''
    });
  };

  handleCodeChange = event => {
    this.setState({ code: event.target.value, codeInputValidateStatus: '', codeInputInvalidMessage: '' });
  };

  handleTitleChange = event => {
    this.setState({ title: event.target.value, titleInputValidateStatus: '', titleInputInvalidMessage: '' });
  };

  setValidFrom = val => {
    this.setState({
      validFrom: val,
      validFromInputValidateStatus: '',
      validFromInputInvalidMessage: ''
    });
  };

  setValidTo = val => {
    this.setState({
      validTo: val,
      validToInputValidateStatus: '',
      validToInputInvalidMessage: ''
    });
  };

  handleIsWithPercentageChange = () => {
    this.setState({ isWithPercentage: !this.state.isWithPercentage });
  };

  createRandomCode = () => {
    this.props.createRandomCode().then(() => {
      this.setState({
        code: this.props.randomCode.code,
        codeInputValidateStatus: '',
        codeInputInvalidMessage: ''
      });
    });
  };

  setAllowedToUse = item => {
    this.setState({
      allowedToUse: { ...item },
      permittedUsersInputValidateStatus: '',
      permittedUsersInputInvalidMessage: ''
    });
  };

  setMinOrderInReservationValue = event => {
    let { value } = event.target;
    this.setState({
      minOrderInReservationValue: value,
      minOrderInReservationValueInputValidateStatus: '',
      minOrderInReservationValueInputInvalidMessage: ''
    });
  };

  setMinSuccessfulReservationValue = event => {
    let { value } = event.target;
    this.setState({
      minSuccessfulReservationValue: value,
      minSuccessfulReservationValueInputValidateStatus: '',
      minSuccessfulReservationValueInputInvalidMessage: ''
    });
  };

  handleMinOrderAmountChange = event => {
    let { value } = event.target;
    this.setState({
      minOrderAmount: value,
      minOrderAmountInputValidateStatus: '',
      minOrderAmountInputInvalidMessage: ''
    });
  };

  renderPermittedUsersInput = () => {
    let {
      searchText,
      isSearched,

      allowedToUse,
      minSuccessfulReservationValue,
      minOrderInReservationValue,

      specialUsers,

      minOrderInReservationValueInputValidateStatus,
      minOrderInReservationValueInputInvalidMessage,

      minSuccessfulReservationValueInputValidateStatus,
      minSuccessfulReservationValueInputInvalidMessage,

      specialUserIdsInputValidateStatus,
      specialUserIdsInputInvalidMessage
    } = this.state;

    let { editMode, searchedSpecialUsersList = [] } = this.props;

    let {
      HAS_MIN_ORDER_IN_RESERVATION,
      HAS_MIN_SUCCESSFUL_RESERVATION,
      SPECIAL_USERS
    } = ENUMS.DISCOUNT_CODE_ALLOWED_USERS.values;

    switch (typeof allowedToUse == 'object' ? allowedToUse.value : allowedToUse) {
      case HAS_MIN_SUCCESSFUL_RESERVATION: {
        return (
          <>
            <label className="col-12" htmlFor="minSuccessfulReservationValue">
              {locales('tables.count')}
            </label>
            <input
              id="minSuccessfulReservationValue"
              name="minSuccessfulReservationValue"
              type="text"
              className={`form-control ${minSuccessfulReservationValueInputValidateStatus}`}
              onChange={this.setMinSuccessfulReservationValue}
              autoComplete="off"
              value={minSuccessfulReservationValue}
            />
            <div className="invalid-feedback">{minSuccessfulReservationValueInputInvalidMessage}</div>
          </>
        );
      }

      case HAS_MIN_ORDER_IN_RESERVATION: {
        return (
          <>
            <label className="col-12" htmlFor="minOrderInReservationValue">
              {locales('tables.mintotalReservePrice')}
            </label>
            <input
              id="minOrderInReservationValue"
              name="minOrderInReservationValue"
              type="text"
              className={`form-control ${minOrderInReservationValueInputValidateStatus}`}
              onChange={this.setMinOrderInReservationValue}
              autoComplete="off"
              value={minOrderInReservationValue}
            />
            <div className="invalid-feedback">{minOrderInReservationValueInputInvalidMessage}</div>
          </>
        );
      }

      case SPECIAL_USERS: {
        return (
          <>
            <label className="col-12" htmlFor="specialUserIds">
              {locales('titles.users')}
            </label>
            <AutoComplete
              id="specialUserIds"
              errorText={specialUserIdsInputInvalidMessage}
              className="col-12"
              name="specialUserIds"
              searchInputClassName={`col-12`}
              inputErrorClassName={`${specialUserIdsInputValidateStatus}`}
              containerClassName="d-flex flex-wrap col"
              searchedList={searchedSpecialUsersList}
              defaultList={specialUsers}
              onSearchInputChanged={this.onSearchInputChanged}
              onSearchComplete={this.handleAutoCompleteDone}
            />
          </>
        );
      }
      default:
        break;
    }
  };

  onSearchInputChanged = searchKey => {
    this.props.fetchSearchedSpecialUsers(`filter=(textPart~contains~${searchKey})`);
  };

  handleAutoCompleteDone = selectedIds => {
    this.setState({
      specialUserIds: selectedIds,
      specialUserIdsInputValidateStatus: '',
      specialUserIdsInputInvalidMessage: ''
    });
  };

  validateForm = () => {
    return new Promise((resolve, reject) => {
      let {
        code,
        title,
        isWithPercentage,
        validFrom,
        validTo,
        allowedToUse,
        specialUserIds,
        discountCodeQuantity,
        minOrderAmount,
        minSuccessfulReservationValue,
        minOrderInReservationValue
      } = this.state;

      const formattedCode = formatter.toStandard(code);
      const formattedTitle = formatter.toStandard(title);

      let isCodeValid,
        isTitleValid,
        isMinOrderAmountValid,
        isvalidFromValid,
        isvalidToValid,
        isDiscountCodeQuantityValid,
        isMinSuccessfulReservationValueValid,
        isMinOrderInReservationValueValid,
        isSpecialUserIdsValid,
        isPermittedUsersValid;

      let firstErrorElementId = '';
      let errors = {};

      if (
        !!allowedToUse &&
        allowedToUse.value == ENUMS.DISCOUNT_CODE_ALLOWED_USERS.values.SPECIAL_USERS &&
        !specialUserIds.length
      ) {
        errors.specialUserIdsInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('tables.specialUsers')
        });
        errors.specialUserIdsInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'specialUserIds';
        isSpecialUserIdsValid = false;
      } else {
        errors.specialUserIdsInputInvalidMessage = '';
        errors.specialUserIdsInputValidateStatus = '';
        isSpecialUserIdsValid = true;
      }

      if (
        !!allowedToUse &&
        allowedToUse.value == ENUMS.DISCOUNT_CODE_ALLOWED_USERS.values.HAS_MIN_SUCCESSFUL_RESERVATION &&
        !minSuccessfulReservationValue
      ) {
        errors.minSuccessfulReservationValueInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('tables.minSuccessfulReservationValue')
        });
        errors.minSuccessfulReservationValueInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'minSuccessfulReservationValue';
        isMinSuccessfulReservationValueValid = false;
      } else {
        errors.minSuccessfulReservationValueInputInvalidMessage = '';
        errors.minSuccessfulReservationValueInputValidateStatus = '';
        isMinSuccessfulReservationValueValid = true;
      }

      if (
        !!allowedToUse &&
        allowedToUse.value == ENUMS.DISCOUNT_CODE_ALLOWED_USERS.values.HAS_MIN_ORDER_IN_RESERVATION &&
        !minOrderInReservationValue
      ) {
        errors.minOrderInReservationValueInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('tables.minOrderInReservation')
        });
        errors.minOrderInReservationValueInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'minOrderInReservationValue';
        isMinOrderInReservationValueValid = false;
      } else {
        errors.minOrderInReservationValueInputInvalidMessage = '';
        errors.minOrderInReservationValueInputValidateStatus = '';
        isMinOrderInReservationValueValid = true;
      }

      if (!allowedToUse) {
        errors.permittedUsersInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('tables.permittedUsersNeeded')
        });
        errors.permittedUsersInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'permittedUsersToUseCode';
        isPermittedUsersValid = false;
      } else {
        errors.permittedUsersInputInvalidMessage = '';
        errors.permittedUsersInputValidateStatus = '';
        isPermittedUsersValid = true;
      }

      if (!isWithPercentage && !minOrderAmount) {
        errors.minOrderAmountInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('tables.minOrder')
        });
        errors.minOrderAmountInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'minOrder';
        isMinOrderAmountValid = false;
      } else {
        errors.minOrderAmountInputInvalidMessage = '';
        errors.minOrderAmountInputValidateStatus = '';
        isMinOrderAmountValid = true;
      }

      if (!discountCodeQuantity) {
        errors.discountCodeQuantityInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('tables.discountValue')
        });
        errors.discountCodeQuantityInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'discountCodeQuantity';
        isDiscountCodeQuantityValid = false;
      } else if (isWithPercentage && discountCodeQuantity > 100) {
        errors.discountCodeQuantityInputInvalidMessage = locales(
          'messages.discountPercentageCannoutBeMoreThan100'
        );
        errors.discountCodeQuantityInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'discountCodeQuantity';
        isDiscountCodeQuantityValid = false;
      } else {
        errors.discountCodeQuantityInputInvalidMessage = '';
        errors.discountCodeQuantityInputValidateStatus = '';
        isDiscountCodeQuantityValid = true;
      }

      if (!validFrom) {
        errors.validFromInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('fields.startDate')
        });
        errors.validFromInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'validFrom';
        isvalidFromValid = false;
      } else {
        errors.validFromInputInvalidMessage = '';
        errors.validFromInputValidateStatus = '';
        isvalidFromValid = true;
      }

      if (!validTo) {
        errors.validToInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('fields.endDate')
        });
        errors.validToInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'validTo';
        isvalidToValid = false;
      } else {
        errors.validToInputInvalidMessage = '';
        errors.validToInputValidateStatus = '';
        isvalidToValid = true;
      }

      if (!formattedCode) {
        errors.codeInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('tables.code')
        });
        errors.codeInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'code';
        isCodeValid = false;
      } else {
        errors.codeInputInvalidMessage = '';
        errors.codeInputValidateStatus = '';
        isCodeValid = true;
      }

      if (!formattedTitle) {
        errors.titleInputInvalidMessage = locales('messages.fieldValueIsRequired', {
          fieldName: locales('tables.title')
        });
        errors.titleInputValidateStatus = 'is-invalid';
        firstErrorElementId = 'title';
        isTitleValid = false;
      } else {
        errors.titleInputInvalidMessage = '';
        errors.titleInputValidateStatus = '';
        isTitleValid = true;
      }

      let isFormValid =
        isCodeValid &&
        isMinOrderAmountValid &&
        isTitleValid &&
        isvalidToValid &&
        isSpecialUserIdsValid &&
        isvalidFromValid &&
        isDiscountCodeQuantityValid &&
        isMinOrderInReservationValueValid &&
        isMinSuccessfulReservationValueValid &&
        isPermittedUsersValid;

      if (!isFormValid) {
        this.setState(
          () => ({
            ...errors
          }),
          () => {
            domManipulator.scrollIntoView(firstErrorElementId);
            resolve(false);
          }
        );
      } else {
        resolve(true);
      }
    });
  };

  saveForm = async event => {
    event.preventDefault();

    const isFormValid = await this.validateForm();
    if (!isFormValid) {
      return;
    }

    domManipulator.scrollToTop();
    let {
      title,
      code,
      isWithPercentage,
      validFrom,
      validTo,
      allowedToUse,
      minOrderAmount,
      discountCodeQuantity,
      minSuccessfulReservationValue,
      minOrderInReservationValue,
      specialUserIds,
      cafeId,
    } = this.state;

    let discountCodeObject = {
      title,
      specialUserIds,
      allowedToUse: typeof allowedToUse == 'object' ? allowedToUse.value : allowedToUse,
      minOrderAmount,
      code,
      minOrderInReservationValue,
      minSuccessfulReservationValue,
      validFrom: formatter.toStandard(jmoment(this.state.validFrom).format('jYYYY/jMM/jDD')),
      validTo: formatter.toStandard(jmoment(this.state.validTo).format('jYYYY/jMM/jDD')),
      amount: discountCodeQuantity,
      cafeId,
      type:
        isWithPercentage == true
          ? ENUMS.DISCOUNT_CODES_TYPES.values.PERCENT
          : ENUMS.DISCOUNT_CODES_TYPES.values.VALUE
    };

    if (!this.props.location.editMode) {
      this.props.insertNewDiscountCode(discountCodeObject).then(() => {
        let {
          insertNewDiscountCodeFailed,
          insertNewDiscountCodeError,
          insertNewDiscountCodeMessage
        } = this.props;
        if (
          insertNewDiscountCodeFailed == false &&
          insertNewDiscountCodeError == false &&
          insertNewDiscountCodeMessage == null
        ) {
          AlertAndConfirmation({
            title: locales('titles.insertedSuccessfully'),
            text: '',
            type: 'success'
          });
          this.props.history.push('/discount-codes');
        }
      });
    } else {
      discountCodeObject = { ...discountCodeObject, id: this.props.location.discountCodeId };
      this.props.updateDiscountCode(discountCodeObject).then(() => {
        let { updateDiscountCodeFailed, updateDiscountCodeError, updateDiscountCodeMessage } = this.props;
        if (
          updateDiscountCodeFailed == false &&
          updateDiscountCodeError == false &&
          updateDiscountCodeMessage == null
        ) {
          AlertAndConfirmation({
            title: locales('titles.editionsDoneSuccessfully'),
            text: '',
            type: 'success'
          });
          this.props.history.push('/discount-codes');
        }
      });
    }
  };

  render() {
    let {
      codeInputInvalidMessage,
      discountCodeQuantityInputInvalidMessage,
      validToInputInvalidMessage,
      validFromInputInvalidMessage,
      titleInputInvalidMessage,
      permittedUsersInputInvalidMessage,
      minOrderAmountInputInvalidMessage,

      title,
      code,
      discountCodeQuantity,
      isWithPercentage,
      minOrderAmount,

      codeInputValidateStatus,
      validFromInputValidateStatus,
      validToInputValidateStatus,
      discountCodeQuantityInputValidateStatus,
      titleInputValidateStatus,
      permittedUsersInputValidateStatus,
      minOrderAmountInputValidateStatus,

      allowedToUse
    } = this.state;

    let {
      discountCodeDetailsLoading,
      discountCodeDetailsFailed,
      discountCodeDetailsMessage,
      discountCodeDetailsError,

      insertNewDiscountCodeLoading,
      insertNewDiscountCodeError,
      insertNewDiscountCodeFailed,
      insertNewDiscountCodeMessage,

      updateDiscountCodeLoading,
      updateDiscountCodeError,
      updateDiscountCodeFailed,
      updateDiscountCodeMessage,

      createRandomCodeLoading,
      createRandomCodeMessage,
      createRandomCodeFailed,
      createRandomCodeError,

      searchedSpecialUsersLoading,
      searchedSpecialUsersError,
      searchedSpecialUsersFailed,
      searchedSpecialUsersMessage
    } = this.props;

    let { editMode } = this.props.location;

    return (
      <>
        <section className="page-header">
          <h1>{editMode ? locales('titles.editDiscountCode') : locales('titles.insertNewDiscountCode')}</h1>
          <div className="form-actions">
            <button onClick={this.saveForm} className="btn btn-success">
              <i className="fa fa-save" />
              {locales('labels.save')}
            </button>
            <Link to="/discount-codes" className="btn btn-default">
              <i className="fa fa-reply" />
              {locales('labels.cancel')}
            </Link>
          </div>
        </section>

        <section>
          <Spin
            spinning={
              discountCodeDetailsLoading ||
              insertNewDiscountCodeLoading ||
              updateDiscountCodeLoading ||
              createRandomCodeLoading ||
              searchedSpecialUsersLoading
            }
          >
            {(discountCodeDetailsError ||
              insertNewDiscountCodeError ||
              updateDiscountCodeError ||
              createRandomCodeError ||
              searchedSpecialUsersError) && (
                <div className="alert alert-danger">{locales('messages.server.error')}</div>
              )}
            {(discountCodeDetailsFailed ||
              insertNewDiscountCodeFailed ||
              updateDiscountCodeFailed ||
              createRandomCodeFailed ||
              searchedSpecialUsersFailed) && (
                <div className="alert alert-danger">
                  {discountCodeDetailsMessage ||
                    insertNewDiscountCodeMessage ||
                    updateDiscountCodeMessage ||
                    createRandomCodeMessage ||
                    searchedSpecialUsersMessage}
                </div>
              )}

            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-12 my-2">
                <label className="col-12" htmlFor="title">
                  {locales('tables.title')}
                </label>
                <input
                  id="title"
                  name="title"
                  type="text"
                  className={`form-control ${titleInputValidateStatus} col-12`}
                  onChange={this.handleTitleChange}
                  autoComplete="off"
                  value={title}
                  maxLength={ENUMS.MAX_LENGTH.discountTitle}
                />
                <small style={{ color: '#555' }}>{locales('maxLength.15')}</small>
                <div className="invalid-feedback">{titleInputInvalidMessage}</div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 my-2">
                <label className="col-12" htmlFor="code">
                  {locales('tables.code')}
                </label>
                <input
                  id="code"
                  name="code"
                  type="text"
                  className={`form-control ${codeInputValidateStatus} col-12`}
                  onChange={this.handleCodeChange}
                  autoComplete="off"
                  value={code}
                  style={{ position: 'relative' }}
                  maxLength={ENUMS.MAX_LENGTH.discountCode}
                />
                <div
                  onClick={this.createRandomCode}
                  className="btn btn-link btn-sm font-smaller pointer"
                  style={{ position: 'absolute', top: '35px', left: '15px' }}
                >
                  {locales('labels.createRandomCode')}
                </div>
                <small style={{ color: '#555' }}>{locales('maxLength.15')}</small>
                <div className="invalid-feedback">{codeInputInvalidMessage}</div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-12 my-2">
                <label className="col-12" htmlFor="validFrom">
                  {locales('tables.creditFrom')}
                </label>
                <DatePicker
                  marge={true}
                  placeholder="تاریخ شروع"
                  id="validFrom"
                  onChange={val => this.setValidFrom(val)}
                  name="validFrom"
                  value={this.state.validFrom}
                  className={`form-control start ${validFromInputValidateStatus} col-12`}
                />
                <div
                  className={`invalid-feedback ${!!validFromInputInvalidMessage ? 'is-invalid-feedback' : ''
                    }`}
                >
                  {validFromInputInvalidMessage}
                </div>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 my-2">
                <label className="col-12" htmlFor="validTo">
                  {locales('tables.till')}
                </label>
                <DatePicker
                  marge={true}
                  placeholder="تاریخ پایان"
                  id="validTo"
                  onChange={val => this.setValidTo(val)}
                  name="validTo"
                  value={this.state.validTo}
                  className={`form-control end ${validToInputValidateStatus} col-12`}
                />

                <div
                  className={`invalid-feedback ${!!validToInputInvalidMessage ? 'is-invalid-feedback' : ''}`}
                >
                  {validToInputInvalidMessage}
                </div>
              </div>
              <div className="col-4 col-sm-12 my-2"></div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-12 my-2">
                <label className="col-12" htmlFor="isWithPercentage">
                  {locales('labels.discountCodeType')}
                </label>

                <input
                  id="withPercentage"
                  name="isWithPercentage"
                  type="radio"
                  onChange={this.handleIsWithPercentageChange}
                  autoComplete="off"
                  checked={isWithPercentage}
                />
                <label htmlFor="withPercentage" className="my-2 mx-3">
                  {locales('labels.withPercentage')}
                </label>

                <input
                  id="withQuantity"
                  name="isWithPercentage"
                  type="radio"
                  onChange={this.handleIsWithPercentageChange}
                  autoComplete="off"
                  checked={!isWithPercentage}
                />
                <label htmlFor="withQuantity" className="my-2 mx-3">
                  {locales('labels.withQuantity')}
                </label>
              </div>
              <div className="col-lg-4 col-md-4 col-sm-12 my-2">
                <label className="col-12" htmlFor="discountCodeQuantity">
                  {locales('tables.discountValue')}
                </label>
                <label
                  className="input-group-text col-3"
                  style={{ position: 'absolute', left: '15px', bottom: '23px', zIndex: '2' }}
                >
                  {isWithPercentage
                    ? locales('labels.withPercentage')
                    : enumHelper.convertEnumValueToTitle(ENUMS.CURRENCY.list, 'TOMAN')}
                </label>

                <input
                  id="discountCodeQuantity"
                  name="discountCodeQuantity"
                  type="text"
                  className={`form-control rounded ${discountCodeQuantityInputValidateStatus}`}
                  onChange={this.handleDiscountCodeQuantityChange}
                  autoComplete="off"
                  value={discountCodeQuantity}
                  style={{ position: 'relative' }}
                />

                <div className="invalid-feedback">{discountCodeQuantityInputInvalidMessage}</div>

                <small className="form-text text-primary px-3">
                  *{isWithPercentage ? locales('titles.percentageHint') : locales('titles.nonPercentageHint')}
                </small>
              </div>
              {!isWithPercentage && (
                <div className="col-lg-4 col-md-4 col-sm-12 my-2">
                  <label className="col-12" htmlFor="title">
                    {locales('tables.minOrder', {
                      fieldName: enumHelper.convertEnumValueToTitle(ENUMS.CURRENCY.list, 'TOMAN')
                    })}
                  </label>
                  <input
                    id="minOrderAmount"
                    name="minOrderAmount"
                    type="text"
                    className={`form-control ${minOrderAmountInputValidateStatus} col-12`}
                    onChange={this.handleMinOrderAmountChange}
                    autoComplete="off"
                    value={minOrderAmount}
                  />
                  <div className="invalid-feedback">{minOrderAmountInputInvalidMessage}</div>
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-4 col-lg-4 my-2">
                <label className="col-12" htmlFor="title">
                  {locales('labels.choosePermittedUsersToUseCode')}
                </label>
                <Select
                  placeholder={
                    allowedToUse && allowedToUse.length
                      ? enumHelper.convertEnumValueToTitle(
                        ENUMS.DISCOUNT_CODE_ALLOWED_USERS.list,
                        allowedToUse
                      )
                      : locales('labels.chooseUsers')
                  }
                  isMulti={false}
                  className={`col-12 rc-dropdown ${!!permittedUsersInputValidateStatus ? 'is-invalid' : ''}`}
                  name="permittedUsersToUseCode"
                  onChange={this.setAllowedToUse}
                  value={allowedToUse}
                  options={ENUMS.DISCOUNT_CODE_ALLOWED_USERS.list.map(item => ({
                    label: item.title,
                    value: item.value
                  }))}
                />
                <div className="col-12 my-2">
                  {!!allowedToUse && this.renderPermittedUsersInput()}
                </div>
              </div>
              
              <div className="col-sm-12 col-md-4 col-lg-4 my-2">
                <label className="col-12">{locales('fields.cafe.name')}</label>
                <Select
                  id="cafeId"
                  name="cafeId"
                  initValue={this.state.cafeId}
                  onChange={selectedCafeId => {
                    this.setState({ cafeId: selectedCafeId.value });
                  }}
                  className={`col-12 p-0 rc-dropdown`}
                  options={this.props.cafeNamesList.map(n => ({
                    label: n.name,
                    value: n.id
                  }))}
                  placeholder={
                    this.state.cafeId !== null
                      ? this.props.cafeNamesList?.find(item => item.id === this.state.cafeId).name
                      : locales('fields.cafe.name')
                  }
                />
              </div>
            </div>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    discountCodeDetails: state.discountCodesReducer.discountCodeDetails,
    discountCodeDetailsLoading: state.discountCodesReducer.discountCodeDetailsLoading,
    discountCodeDetailsError: state.discountCodesReducer.discountCodeDetailsError,
    discountCodeDetailsFailed: state.discountCodesReducer.discountCodeDetailsFailed,
    discountCodeDetailsMessage: state.discountCodesReducer.discountCodeDetailsMessage,

    insertNewDiscountCodeLoading: state.discountCodesReducer.insertNewDiscountCodeLoading,
    insertNewDiscountCodeError: state.discountCodesReducer.insertNewDiscountCodeError,
    insertNewDiscountCodeFailed: state.discountCodesReducer.insertNewDiscountCodeFailed,
    insertNewDiscountCodeMessage: state.discountCodesReducer.insertNewDiscountCodeMessage,

    updateDiscountCodeLoading: state.discountCodesReducer.updateDiscountCodeLoading,
    updateDiscountCodeError: state.discountCodesReducer.updateDiscountCodeError,
    updateDiscountCodeFailed: state.discountCodesReducer.updateDiscountCodeFailed,
    updateDiscountCodeMessage: state.discountCodesReducer.updateDiscountCodeMessage,

    createRandomCodeLoading: state.discountCodesReducer.createRandomCodeLoading,
    createRandomCodeFailed: state.discountCodesReducer.createRandomCodeFailed,
    createRandomCodeError: state.discountCodesReducer.createRandomCodeError,
    createRandomCodeMessage: state.discountCodesReducer.createRandomCodeMessage,
    randomCode: state.discountCodesReducer.randomCode,

    searchedSpecialUsersLoading: state.discountCodesReducer.searchedSpecialUsersLoading,
    searchedSpecialUsersFailed: state.discountCodesReducer.searchedSpecialUsersFailed,
    searchedSpecialUsersError: state.discountCodesReducer.searchedSpecialUsersError,
    searchedSpecialUsersMessage: state.discountCodesReducer.searchedSpecialUsersMessage,
    searchedSpecialUsers: state.discountCodesReducer.searchedSpecialUsers,
    searchedSpecialUsersList: state.discountCodesReducer.searchedSpecialUsersList,

    cafeNamesList: state.cafesReducer.cafeNamesList,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchSearchedSpecialUsers: search => dispatch(discountCodesActions.fetchSearchedSpecialUsers(search)),
    fetchDiscountCodeById: id => dispatch(discountCodesActions.fetchDiscountCodeById(id)),
    insertNewDiscountCode: discountCodeObject =>
      dispatch(discountCodesActions.insertNewDiscountCode(discountCodeObject)),
    updateDiscountCode: discountCodeObject =>
      dispatch(discountCodesActions.updateDiscountCode(discountCodeObject)),
    createRandomCode: () => dispatch(discountCodesActions.createRandomCode()),
    getAllCafeNamesForPanel: () => dispatch(cafeActions.getAllCafeNamesForPanel()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddOrEditDiscountCode));
